export const BILLING_ENDPOINTS = {
  root: '/billing',
  autodebit: '/billing/autodebit',
  info: '/billing/info',
  balance: '/billing/balance',
  history: '/billing/history',
  topUp: '/billing/top-up',
  topUpSubscription: '/billing/top-up/subscription',
  creditsPacks: '/billing/credits/packs',
  creditsBuy: '/billing/credits/buy',
  wireInvoices: '/billing/wire-transfer/invoices',
  wireInvoicesPreview: '/billing/wire-transfer/invoices/preview',
  stripeInvoices: '/billing/stripe/invoices',
} as const;
